import { render, staticRenderFns } from "./Exchange.vue?vue&type=template&id=9e76f994&scoped=true&"
import script from "./Exchange.vue?vue&type=script&lang=js&"
export * from "./Exchange.vue?vue&type=script&lang=js&"
import style0 from "./Exchange.vue?vue&type=style&index=0&id=9e76f994&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e76f994",
  null
  
)

export default component.exports